/**
 * Utility for handling hash-based scrolling
 */
export const hashScroll = {
    /**
     * Initialize hash scroll functionality
     */
    init() {
        // Check for hash on page load
        this.scrollToHash();

        // Listen for hash changes
        window.addEventListener('hashchange', () => {
            this.scrollToHash();
        });
    },

    /**
     * Scroll to the element with the ID matching the hash
     */
    scrollToHash() {
        const hash = window.location.hash;
        if (hash) {
            // Remove the # from the hash
            const id = hash.substring(1);
            const element = document.getElementById(id);
            
            if (element) {
                // Use smooth scrolling
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }
};

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
    hashScroll.init();
}); 